import { useQuery } from '@tanstack/react-query';
import ApiKeyService from '../services/api-key.service';

export function useAdminApiKey(apiKeyId: string | undefined) {
  return useQuery({
    queryKey: ['api-key', apiKeyId],
    queryFn: () => ApiKeyService.getApiKeyById(apiKeyId!),
    enabled: !!apiKeyId,
  });
}
